import { VOUCHER_STATUS_AVAILABLE, VOUCHER_STATUS_EXPIRED, VOUCHER_STATUS_ONHOLD, VOUCHER_STATUS_REFUNDED, VOUCHER_STATUS_USED } from "../../../component/Constants";
import { useStatusValuesVoucher } from "../../../component/useStatusValuesVoucher";
import {Checkbox, ListItemText, MenuItem, TextField} from "@mui/material";
import { useTranslation } from "react-i18next";
export const useVoucherStatuses = () => {
    const { getStatusColorVoucher,getStatusLabelVoucher } = useStatusValuesVoucher();
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'voucher'});
    const statuses = [
        {
            value: VOUCHER_STATUS_AVAILABLE,
            label: getStatusLabelVoucher(VOUCHER_STATUS_AVAILABLE),
            color: getStatusColorVoucher(VOUCHER_STATUS_AVAILABLE)
        },
        {
            value: VOUCHER_STATUS_EXPIRED,
            label: getStatusLabelVoucher(VOUCHER_STATUS_EXPIRED),
            color: getStatusColorVoucher(VOUCHER_STATUS_EXPIRED)
        },
        {
            value: VOUCHER_STATUS_REFUNDED,
            label: getStatusLabelVoucher(VOUCHER_STATUS_REFUNDED),
            color: getStatusColorVoucher(VOUCHER_STATUS_REFUNDED)
        },
        {
            value: VOUCHER_STATUS_USED,
            label: getStatusLabelVoucher(VOUCHER_STATUS_USED),
            color: getStatusColorVoucher(VOUCHER_STATUS_USED)
        },
        {
            value: VOUCHER_STATUS_ONHOLD,
            label: getStatusLabelVoucher(VOUCHER_STATUS_ONHOLD),
            color: getStatusColorVoucher(VOUCHER_STATUS_ONHOLD)
        },
    ];

    


    return {statuses}
}